import { useEffect, useState } from 'react';

// true, если на мобильном (<1024px) открыта экранная клавиатура.
// Основной сигнал — focus/blur на text input / textarea / contentEditable:
// на мобильном фокус в текстовом поле = открытая клавиатура.
// Это надёжнее, чем visualViewport.resize (который не всегда срабатывает
// в Android WebView и в DevTools-эмуляции).
export function useKeyboardOpen() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const isMobile = () => window.innerWidth < 1024;
    const isTextInput = (el) => {
      if (!el || el.disabled || el.readOnly) return false;
      if (el.tagName === 'TEXTAREA') return true;
      if (el.tagName === 'INPUT') {
        const t = (el.type || 'text').toLowerCase();
        return ['text', 'search', 'email', 'url', 'tel', 'password', 'number'].includes(t);
      }
      return !!el.isContentEditable;
    };

    const onFocusIn = (e) => {
      if (isMobile() && isTextInput(e.target)) setOpen(true);
    };
    const onFocusOut = () => {
      // Пауза, чтобы поймать перефокусировку между полями без моргания.
      setTimeout(() => {
        if (!isMobile() || !isTextInput(document.activeElement)) setOpen(false);
      }, 0);
    };

    document.addEventListener('focusin', onFocusIn);
    document.addEventListener('focusout', onFocusOut);

    // Начальное состояние — если на маунте уже сфокусировано поле.
    if (isMobile() && isTextInput(document.activeElement)) setOpen(true);

    return () => {
      document.removeEventListener('focusin', onFocusIn);
      document.removeEventListener('focusout', onFocusOut);
    };
  }, []);

  return open;
}
